module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAFxJREFUSEvt07EKwCAMhOHfre59WPsE9WHd201XB8tBQLpc1iQcfCGpQWdjJQcoXRMpIUwUInqBR26uBzJwzK3VDeoJVySgwQ2U3wO2E0V0Pnf8B5LTRCaSAnJgALYROCEWRUo4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hide-icon.png
// module id = 4Qsk
// module chunks = 1